import { IconBriefcase } from "@tabler/icons-react";
import styles from "./jobs.module.css";

const JobsHero = ({ total, active, applicants, inReview }) => {
  return (
    <div className={styles.jobsHero}>
      <div className={styles.jobsHeroText}>
        <div className={styles.jobsHeroEyebrow}>
          <IconBriefcase size={14} /> Job Management
        </div>
        <div className={styles.jobsHeroTitle}>Manage your job listings</div>
        <div className={styles.jobsHeroSub}>
          Track applications, review candidates, and keep your listings up to
          date — all in one place.
        </div>
      </div>
      <div className={styles.jobsHeroStats}>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{total}</div>
          <div className={styles.heroStatLabel}>Total Jobs</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{active}</div>
          <div className={styles.heroStatLabel}>Active</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{applicants}</div>
          <div className={styles.heroStatLabel}>Applicants</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{inReview}</div>
          <div className={styles.heroStatLabel}>In Review</div>
        </div>
      </div>
    </div>
  );
};
export default JobsHero;
